export default "__VITE_ASSET__i5IVY0Qx__"